import React from 'react'
import { MaterialIconId } from './MaterialIconId.type'
import { MaterialIconSize } from './MaterialIconSize.type'

export type MaterialIconProps = {
  icon: MaterialIconId
  className?: string
  size?: MaterialIconSize
  style?: React.CSSProperties
  ariaLabel?: string
  testId?: string
}

export const MaterialIcon = (props: MaterialIconProps) => {
  const { icon, style, size, className, ariaLabel, testId } = props

  const classList = []

  switch (size) {
    case MaterialIconSize.size14:
      classList.push('adel-material-symbols-14')
      break
    case MaterialIconSize.size16:
      classList.push('adel-material-symbols-16')
      break
    case MaterialIconSize.size18:
      classList.push('adel-material-symbols-18')
      break
    case MaterialIconSize.size20:
      classList.push('adel-material-symbols-20')
      break
    case MaterialIconSize.size24:
      classList.push('adel-material-symbols-24')
      break
    case MaterialIconSize.size36:
      classList.push('adel-material-symbols-36')
      break
    default:
      classList.push('adel-material-symbols')
      break
  }

  if (className) {
    classList.push(className)
  }

  return (
    <span
      className={classList.join(' ')}
      style={style}
      data-testid={testId ? `${testId}-icon` : null}
      aria-label={ariaLabel || undefined}
      aria-hidden={ariaLabel ? undefined : 'true'}
    >
      {icon}
    </span>
  )
}
